import { useContext, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import {
  HeroContainer,
  HeadlineStyled,
  SubHeadlineStyled,
} from './Hero.styles';
import HeroBackground from './Hero.Background';
import HeaderHeightContext from '~/helpers/HeaderHeightContext';
import PageTypeContext from '~/helpers/PageTypeContext';
import useWindowSize from '~/hooks/useWindowSize';

const StyledContainerGrid = styled.div`
  z-index: 11;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: absolute;
  bottom: 10%;
  margin: 0 auto;
  padding: 0px 8%;
  ${(props) =>
    props.direction === 'RIGHT'
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `}
  p + p {
    margin-top: 0;
  }
`;

/**
 * This fuction was calculated manually using math acording the width of the viewport, the text lenght and the desired output
 * @param {number} contentLength
 * @param {width} contentLength
 * @returns {string}
 */
const getRelativeFontSize = (contentLength, width) => {
  const fontSize = 70 / (contentLength * (width / 1000));
  const maxSize = 22 - contentLength;
  const sizeInPixels = window.innerWidth * (maxSize / 100);
  const maxPixelSize = 112;

  if (sizeInPixels > maxPixelSize) {
    return '112px';
  }
  return `${fontSize > maxSize ? maxSize : fontSize}vw`;
};

/**
 * @param {HeroSingleHighlightProps} props
 * @returns {React.ReactElement} The rendered component
 */
export const HeroSingleHighlight = ({
  image,
  smallImage,
  format = 'LEFT',
  lines = undefined,
}) => {
  const windowSize = useWindowSize();
  const headerHeight = useContext(HeaderHeightContext);
  const pageType = useContext(PageTypeContext);
  const [fontSize, setFontSize] = useState('');

  // Effect to define an initial font size for the middle lane
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (
      lines &&
      lines.middle &&
      fontSize === '' &&
      typeof window !== 'undefined' &&
      windowSize &&
      windowSize.width > 0
    ) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setFontSize(getRelativeFontSize(lines.middle.length, windowSize.width));
    }
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */
  // Effect to handle the font size for the middle lane when the screen size changes
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (
      lines &&
      lines.middle &&
      fontSize !== '' &&
      typeof window !== 'undefined' &&
      windowSize &&
      windowSize.width > 0
    ) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setFontSize(getRelativeFontSize(lines.middle.length, windowSize.width));
    }
  }, [windowSize]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <HeroContainer $fullWidth={true}>
      <HeroBackground
        mobileImage={smallImage}
        background={image}
        heroEVP
        context="HERO_SINGLE_HIGHLIGHT"
      />
      {lines && (lines.middle ? fontSize : true) && (
        <StyledContainerGrid direction={format}>
          {lines?.top && (
            <SubHeadlineStyled>{lines.top.toUpperCase()}</SubHeadlineStyled>
          )}
          {lines?.middle && (
            <HeadlineStyled fontSize={fontSize}>
              {lines.middle.toUpperCase()}
            </HeadlineStyled>
          )}
          {lines?.bottom && (
            <SubHeadlineStyled>{lines.bottom.toUpperCase()}</SubHeadlineStyled>
          )}
        </StyledContainerGrid>
      )}
    </HeroContainer>
  );
};
